import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setSubscribeStatus('Please enter a valid email address');
      return;
    }
    
    // Here you would typically send the email to your newsletter service
    console.log('Subscribing email:', email);
    
    // Simulate success
    setSubscribeStatus('Thanks for subscribing!');
    setEmail('');
    
    // Clear status after 3 seconds
    setTimeout(() => {
      setSubscribeStatus('');
    }, 3000);
  };

  return (
    <footer className="bg-black text-white pt-16 pb-4">
      <div className="container mx-auto px-4">

        {/* NAP Bar — matches Google Business Profile exactly */}
        <div className="border border-gray-800 rounded-2xl mb-12 px-6 py-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="flex items-start gap-3">
            <svg className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <div>
              <p className="text-yellow-500 text-xs font-semibold uppercase tracking-wider mb-1">Address</p>
              <address className="text-gray-300 text-sm not-italic leading-snug">
                9600 Southland Cir SW #2710<br />Calgary, AB T2V 5A1, Canada
              </address>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <svg className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <div>
              <p className="text-yellow-500 text-xs font-semibold uppercase tracking-wider mb-1">Phone</p>
              <a href="tel:+18259063078" className="text-gray-300 text-sm hover:text-white transition-colors">
                +1 (825) 906-3078
              </a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <svg className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <div>
              <p className="text-yellow-500 text-xs font-semibold uppercase tracking-wider mb-1">Email</p>
              <a href="mailto:outreach@quickgrowth.ai" className="text-gray-300 text-sm hover:text-white transition-colors">
                outreach@quickgrowth.ai
              </a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <svg className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p className="text-yellow-500 text-xs font-semibold uppercase tracking-wider mb-1">Hours</p>
              <p className="text-gray-300 text-sm leading-snug">Mon – Fri, 9:00 AM – 5:30 PM MST</p>
            </div>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Company Info Column */}
          <div>
            <div className="mb-6 flex justify-center md:justify-start">
              <img src="/images/logo.svg" alt="QuickGrowth" className="h-16" />
            </div>
            <p className="text-gray-400 text-center md:text-left mb-6">
              At <span className="text-yellow-500">Quick Growth</span>, we offer affordable and comprehensive solutions that empower, drive growth, and enhance efficiency to meet your unique needs.
            </p>
            
            {/* Social Media Icons */}
            <div className="flex justify-center md:justify-start space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd"></path>
                </svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd"></path>
                </svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.418-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd"></path>
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
                </svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
                </svg>
              </a>
              <a href="https://discord.gg/ZuYTHTEh" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors" title="Join our Discord">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057c.002.022.015.043.033.055a19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Company Links Column */}
          <div>
            <h3 className="text-yellow-500 font-bold text-xl mb-6 uppercase">COMPANY</h3>
            <ul className="space-y-3">
              <li><Link to="/about-us" className="text-gray-400 hover:text-white transition-colors">ABOUT US</Link></li>
              <li><Link to="/contact-us" className="text-gray-400 hover:text-white transition-colors">LOCATION</Link></li>
              <li><Link to="/faqs" className="text-gray-400 hover:text-white transition-colors">FAQS</Link></li>
              <li><Link to="/contact-us" className="text-gray-400 hover:text-white transition-colors">CONTACT</Link></li>
              <li><Link to="/terms" className="text-gray-400 hover:text-white transition-colors">TERMS OF SERVICE</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">PRIVACY POLICY</Link></li>
            </ul>
          </div>

          {/* Services Links Column */}
          <div>
            <h3 className="text-yellow-500 font-bold text-xl mb-6 uppercase">SERVICES</h3>
            <ul className="space-y-3">
              <li><Link to="/services/artificial-intelligence" className="text-gray-400 hover:text-white transition-colors">AI SOLUTIONS</Link></li>
              <li><Link to="/services/web/website-design-development" className="text-gray-400 hover:text-white transition-colors">WEB & SOFTWARE DEVELOPMENT</Link></li>
              <li><Link to="/services/software-development" className="text-gray-400 hover:text-white transition-colors">SOFTWARE DEVELOPMENT</Link></li>
              <li><Link to="/services/branding" className="text-gray-400 hover:text-white transition-colors">BRANDING & CREATIVE SERVICES</Link></li>
            </ul>
          </div>

          {/* Newsletter Subscription Column */}
          <div>
            <h3 className="text-yellow-500 font-bold text-xl mb-6 uppercase">JOIN OUR NEWSLETTER</h3>
            <p className="text-gray-400 mb-4">
            Stay updated with insights, trends, and growth strategies delivered weekly.
            </p>
            
            <form onSubmit={handleSubscribe} className="space-y-3">
              <div className="flex flex-col space-y-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="ENTER YOUR EMAIL"
                  className="bg-transparent border border-gray-700 rounded-full py-3 px-4 text-white placeholder-gray-500 focus:outline-none focus:border-yellow-500"
                  required
                />
                <button 
                  type="submit"
                  className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold rounded-full py-3 px-6 transition-colors duration-300"
                >
                  Send
                </button>
              </div>
              {subscribeStatus && (
                <p className={`text-sm ${subscribeStatus.includes('Thanks') ? 'text-green-500' : 'text-red-500'}`}>
                  {subscribeStatus}
                </p>
              )}
            </form>
          </div>
        </div>

        {/* Copyright Bar */}
        <div className="border-t border-gray-800 mt-16 pt-6 space-y-3">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
            <Link to="/terms" className="text-gray-500 hover:text-gray-300 text-xs transition-colors">Terms of Service</Link>
            <span className="text-gray-700 text-xs hidden sm:inline">·</span>
            <Link to="/privacy" className="text-gray-500 hover:text-gray-300 text-xs transition-colors">Privacy Policy</Link>
            <span className="text-gray-700 text-xs hidden sm:inline">·</span>
            <a href="mailto:privacy@quickgrowth.ai" className="text-gray-500 hover:text-gray-300 text-xs transition-colors">Unsubscribe / Opt-Out</a>
          </div>
          <p className="text-gray-500 text-center text-xs">
            COPYRIGHT 2025 QUICKGROWTH.AI — All rights reserved. Registered in Canada.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;